import { PlanningContext, EvaluatedCandidate, IEvaluator, PlanningState } from "@/core/battle/ai/types/ai.types";
import { EvaluatorUtils } from "@/core/battle/ai/utils/evaluatorUtils";
import { CombatCalculator } from "@/core/battle/CombatCalculator";
import { BattleUnit, Skill } from "@/core/types/battle.types";
import { getUnitTotalHp } from "@/core/utils/battle.utils";
import { coordsToId, getHexDistance } from "@/core/utils/hex.utils";

export class AttackEvaluator implements IEvaluator<BattleUnit> {
    evaluate(
        state: PlanningState,
        ctx: PlanningContext,
        target: BattleUnit,
        skill: Skill,
    ): EvaluatedCandidate {
        const attackerHexId = coordsToId(state.position);
        const targetHexId = coordsToId(target);

        const terrainBonuses = CombatCalculator.getTerrainBonuses(
            ctx.storeState.battleMap.get(attackerHexId)?.terrain,
            ctx.storeState.battleMap.get(targetHexId)?.terrain
        );

        const damage = CombatCalculator.calculateSkillRawDamage(
            ctx.unit,
            target,
            skill,
            true,
            terrainBonuses
        );

        const attackerSkill = Math.max(
            ctx.unit.stats.rangedSkill || 0,
            ctx.unit.stats.meleeSkill || 0
        );

        const targetValue = EvaluatorUtils.calculateStackPower(target);
        const targetWeight = targetValue / ctx.totalEnemiesValue;
        let dist = 1;
        if (skill.range > 2) {
            dist = getHexDistance(state.position, target);
        }
        const hitChance = CombatCalculator.getHitChance(ctx.unit, attackerSkill, target, skill, dist, terrainBonuses);
        const expectedDamage = damage * (hitChance / 100);
        // const damagePercent = expectedDamage / (targetValue/getUnitTotalHp(target));

        // const lethality = Math.min(1.0, damagePercent * targetWeight);
        const lethality = Math.min(1.0, (expectedDamage / getUnitTotalHp(target)) * targetWeight);

        return {
            utility: lethality,
            components: {
                baseDamage: damage,
                hitChance,
                expectedDamage,
                total: lethality
            }
        };
    }
}